import { render, staticRenderFns } from "./TableTab.vue?vue&type=template&id=02d22d57&scoped=true"
import script from "./TableTab.vue?vue&type=script&lang=js"
export * from "./TableTab.vue?vue&type=script&lang=js"
import style0 from "./TableTab.vue?vue&type=style&index=0&id=02d22d57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d22d57",
  null
  
)

export default component.exports